import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

type Props = {
  visible: boolean
  onHide: () => void
  onProceed: () => void
}

const NotificationDisabledDialog = (props: Props) => {
  const header = 'Notification Disabled'
  const footer = (
    <div className="text-center">
      <Button label="CANCEL" className="default-cancel-button" onClick={props.onHide} />
      <Button label="PROCEED" className="default-save-button" onClick={props.onProceed} />
    </div>
  )

  return (
    <Dialog
      header={header}
      footer={footer}
      className="default"
      visible={props.visible}
      onHide={props.onHide}
    >
      The selected recipients in both To and CC have their GMAWB notifications turned off and will
      not receive an email notification for this update. <br /> <br /> However, the assigned GMAWB
      handler will still be updated successfully.
    </Dialog>
  )
}

export default NotificationDisabledDialog
